// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wj0Ca9f6eLE4buG2k9qh .vkLVcopAsFP9lvwjbaSM{justify-content:space-between;align-items:center;gap:8px;margin-bottom:24px;display:flex}.Wj0Ca9f6eLE4buG2k9qh .XP0wlKJPiDI_YxvpsqVC{cursor:pointer;color:var(--action-contained-primary-normal);text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Wj0Ca9f6eLE4buG2k9qh`,
	"info": `vkLVcopAsFP9lvwjbaSM`,
	"link": `XP0wlKJPiDI_YxvpsqVC`
};
export default ___CSS_LOADER_EXPORT___;
